import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const filePicker: ThemeUICSSObject = {
  '[aria-hidden="true"][aria-live="polite"]': { display: 'none' },

  '.rc-tree .rc-tree-treenode': {
    display: 'flex',
    alignItems: 'center',
  },

  '.rc-tree .rc-tree-treenode .rc-tree-node-content-wrapper': {
    display: 'inline-flex',
    alignItems: 'center',
  },

  '.rc-tree .rc-tree-treenode span.rc-tree-switcher, .rc-tree .rc-tree-treenode span.rc-tree-checkbox, .rc-tree .rc-tree-treenode span.rc-tree-iconEle':
    {
      minWidth: '32px',
      width: '32px',
      height: '32px',
      lineHeight: '32px',
      textAlign: 'center',
      color: 'palette.primary.dark',
    },

  '.rc-tree .rc-tree-treenode span.rc-tree-switcher': {
    background: 'none',
    textAlign: 'center',
  },

  '.rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-icon__customize, .rc-tree .rc-tree-treenode span.rc-tree-checkbox.rc-tree-icon__customize, .rc-tree .rc-tree-treenode span.rc-tree-iconEle.rc-tree-icon__customize':
    {
      width: '32px',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
    },

  '.rc-tree-indent-unit, .rc-tree-switcher, .rc-tree-switcher-noop': {
    minWidth: '32px',
    width: '32px',
  },

  '.rc-tree-child-tree': {
    display: 'block',
  },

  '.node-motion': {
    transition: 'all .3s',
    overflow: 'hidden',
  },
};

export default filePicker;
